// extracted by mini-css-extract-plugin
export default {"box":"categoryPage_box__m6Xtr"};